@switch (kind) {
  @case ('ending') {
    <div class="bsb bsb--warn" dir="rtl" role="status">
      <i class="mdi mdi-timer-sand"></i>
      <span>מנוי ה-VIP מסתיים בעוד <b>{{ status?.days_left }}</b> ימים ({{ status?.vip_until | date:'dd/MM/yyyy' }}).
        חדשו כדי לשמור על התג העסקי, עמוד העסק וכל המודעות.</span>
      <a class="bsb__cta" [routerLink]="['/personal/vip-subscription']">חידוש מנוי</a>
    </div>
  }
  @case ('grace') {
    <div class="bsb bsb--danger" dir="rtl" role="status">
      <i class="mdi mdi-alert-circle"></i>
      <span>המנוי הסתיים. העסק ממשיך להופיע עד <b>{{ status?.grace_until | date:'dd/MM/yyyy' }}</b>,
        ואחר כך החשבון יחזור לחשבון רגיל.
        @if (status?.free_ads_after_lapse) {
          רק {{ status?.free_ads_after_lapse }} המודעות האחרונות שפורסמו במסגרת המנוי יישארו פעילות, והשאר יושהו
        } @else {
          המודעות שפורסמו במסגרת המנוי יושהו
        }
        ויחזרו לפעילות אוטומטית כשתחדשו את המנוי.</span>
      <a class="bsb__cta" [routerLink]="['/personal/vip-subscription']">חידוש מנוי</a>
    </div>
  }
  @case ('lapsed') {
    <div class="bsb bsb--muted" dir="rtl" role="status">
      <i class="mdi mdi-pause-circle"></i>
      <span>החשבון חזר לחשבון רגיל. {{ status?.paused_ads_count }} מודעות מושהות — הן יחזרו לפעילות אוטומטית עם חידוש המנוי.
        פרטי העסק והיסטוריה נשמרו.</span>
      <a class="bsb__cta" [routerLink]="['/personal/vip-subscription']">חידוש מנוי</a>
    </div>
  }
  @case ('profile') {
    <div class="bsb bsb--info" dir="rtl" role="status">
      <i class="mdi mdi-store"></i>
      <span>אתם מוצגים כעסק בכל המודעות. רוצים שיופיעו גם שם, לוגו ותחומי פעילות?</span>
      <a class="bsb__cta" [routerLink]="['/personal/store']">הגדרת פרופיל עסקי</a>
      <button type="button" class="bsb__x" (click)="dismissed = true" aria-label="סגור">×</button>
    </div>
  }
}
